import { CreateExerciseCategoryDTO, ExerciseCategoryDTO } from '@/generated';
import { exerciseCategoryApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';

const refreshChannel = new BroadcastChannel('exercise-category-refresh');

export const useCreateExerciseCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createExerciseCategoryDTO: CreateExerciseCategoryDTO) => exerciseCategoryApi.exerciseCategoryCreate({ createExerciseCategoryDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.ExerciseCategories] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useUpdateExerciseCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updateExerciseCategory: ExerciseCategoryDTO) => exerciseCategoryApi.exerciseCategoryUpdate({ exerciseCategoryDTO: updateExerciseCategory }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.ExerciseCategories] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useDeleteExerciseCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (exerciseCategoryId: string) => exerciseCategoryApi.exerciseCategoryDelete({ exerciseCategoryId }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.ExerciseCategories] });
      refreshChannel.postMessage('refresh');
    },
  });
};
